import {
  SELECTED_CALCULATED_TYPE,
  SELECTED_EMPLOYEES,
} from '@/store/actions/payroll';

const mutations = {
  [SELECTED_EMPLOYEES]: (state, value) => {
    state.selectedEmployees = value;
  },
  [SELECTED_CALCULATED_TYPE]: (state, value) => {
    state.selectedCalculatedType = value;
  },
};

const getters = {
  getSelectedEmployees: (state) => state.selectedEmployees,
  getSelectedCalculatedType: (state) => state.selectedCalculatedType,
};

const state = () => ({
  selectedEmployees: [],
  selectedCalculatedType: '',
});

export default () => ({
  getters,
  mutations,
  state,
});
